

export class DeviceModelPortAllocationOutputWithoutStatus implements IDeviceModelPortAllocationOutputWithoutStatus {
    /** The auto-generated id of the deviceModelPortAllocation master */
    device_model_port_allocation_id!: number;
    /** The deviceModelPortAllocation name with 255 character limit */
    device_model_port_allocation_name!: string;

    constructor(data?: IDeviceModelPortAllocationOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_model_port_allocation_id = _data["device_model_port_allocation_id"];
            this.device_model_port_allocation_name = _data["device_model_port_allocation_name"];
        }
    }

    static fromJS(data: any): DeviceModelPortAllocationOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelPortAllocationOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_model_port_allocation_id"] = this.device_model_port_allocation_id;
        data["device_model_port_allocation_name"] = this.device_model_port_allocation_name;
        return data; 
    }
}

export interface IDeviceModelPortAllocationOutputWithoutStatus {
    /** The auto-generated id of the deviceModelPortAllocation master */
    device_model_port_allocation_id: number;
    /** The deviceModelPortAllocation name with 255 character limit */
    device_model_port_allocation_name: string;
}

